module.exports = new __parcel__URL__("swiftjustice.fd81a73b.png").toString();